import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getBroadcastState } from "@/lib/api";

const BroadcastContext = createContext(null);

const INITIAL_STATE = {
  mode: "live",
  dynamic: "trivia",
  commercial_ends_at: null,
  updated_at: null,
  source: "default",
};

export const BroadcastProvider = ({ children }) => {
  const [state, setState] = useState(INITIAL_STATE);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setState(await getBroadcastState());
    } catch {
      // Mantiene el último estado visible si la señal no está disponible.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const interval = window.setInterval(refresh, 10000);
    return () => window.clearInterval(interval);
  }, [refresh]);

  useEffect(() => {
    if (state.mode !== "commercials" || !state.commercial_ends_at) return undefined;
    const interval = window.setInterval(() => {
      if (new Date(state.commercial_ends_at) <= new Date()) refresh();
    }, 1000);
    return () => window.clearInterval(interval);
  }, [state.commercial_ends_at, state.mode, refresh]);

  return (
    <BroadcastContext.Provider value={{ state, loading, refresh }}>
      {children}
    </BroadcastContext.Provider>
  );
};

export const useBroadcast = () => {
  const context = useContext(BroadcastContext);
  if (!context) throw new Error("useBroadcast debe usarse dentro de BroadcastProvider");
  return context;
};